import MenuButton from 'components/DropdownMenu/MenuButton';

const CIRCLE =
  'flex h-8 w-8 items-center justify-center rounded-full border border-gray-100 text-gray-900 transition-colors group-hover:border-gray-200 group-hover:bg-gray-100';
const ACTION = 'group flex flex-col items-center gap-1.5 text-xs text-gray-700 transition-colors hover:text-gray-900';

const QuickAction = ({ icon: Icon, label, onClick }) => (
  <button type="button" onClick={onClick} className={ACTION}>
    <span className={CIRCLE}>
      <Icon wh={14} color="currentColor" />
    </span>
    {label}
  </button>
);

/**
 * The row of the record's actions, as on the prototype: a round icon over
 * its name (Note, E-mail, Appel, Tâche, RDV…). `more`: the items of a last
 * « Plus » action, which opens a menu.
 */
const QuickActions = ({ actions, more, moreLabel, moreIcon }) => (
  <div className="mt-4 flex justify-between">
    {actions.map((action) => (
      <QuickAction key={action.key} {...action} />
    ))}
    {more?.length > 0 && (
      <MenuButton
        items={more}
        trigger={(toggle) => <QuickAction icon={moreIcon} label={moreLabel} onClick={toggle} />}
      />
    )}
  </div>
);

export default QuickActions;
